import {
  ADD_PRODUCT_KEYVALUE,
  DELETE_PRODUCT_KEYVALUE,
  ADD_PRODUCT_IMAGE,
  DELELTE_PRODUCT_IMAGE,
  ADD_PRODUCT_SELLER,
  DELETE_PRODUCT_SELLER,
  ADD_PRODUCT_FEATURE,
  DELETE_PRODUCT_FEATURE,
  ADD_SELLER_FEATURE,
  DELETE_SELLER_FEATURE,
  GET_CATEGORIES_SAGA,
  CREATE_PRODUCT_SAGA,
  GET_SUBCATEGORIES_SAGA, 
  GET_SECOND_SUBCATEGORIES_SAGA,
  END_CREATION_LOADING,
  ADD_TAG,
  DELETE_TAG,
  ADD_KEYVALUE,
  GET_CATEGORY_FEATURES_SAGA,
  GET_BRANDS_SAGA,
} from "../actionTypes";

const INITIAL_STATE = {
  loading: false,
  status: null,
  allBrands: [],
  allFeatures: [],
  allCategoriesList: [],
  allSubCategoriesList: [],
  allSecondSubCategoriesList: [],
  selectedBrand: null,
  selectedCategory: null,
  selectedSubCategory: null,
  selectedSecondSubCategory: null,
  selectedPallete: null,
  mustHaveSecondSubCategory: false,
  productObject: {
    ProductTitle: null,
    expirationTime: null,
    IsFori: null,
    Discount: null,
    SubCategoryId: null,
    BrandId: null,
    Tags: null,
    Images: [],
    ProductSellers: [],
    Features: [],
    SellerFeatures: "",
    Description: null,
  },
};

const createProductReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_KEYVALUE:
      return { ...state, [payload.key]: payload.value };
    case ADD_PRODUCT_KEYVALUE:
      return {
        ...state,
        productObject: { ...state.productObject, [payload.key]: payload.value },
      };
    case DELETE_PRODUCT_KEYVALUE:
      return {
        ...state,
        productObject: { ...state.productObject, [payload.key]: null },
      };
    case ADD_PRODUCT_IMAGE:
      return {
        ...state,
        productObject: {
          ...state.productObject,
          Images: [...state.productObject.Images, payload],
        },
      };
    case DELELTE_PRODUCT_IMAGE:
      return {
        ...state,
        productObject: {
          ...state.productObject.productObject,
          Images: payload,
        },
      };
    case ADD_PRODUCT_SELLER:
      return {
        ...state,
        productObject: {
          ...state.productObject,
          ProductSellers: [...state.productObject.ProductSellers, payload],
        },
      };
    case DELETE_PRODUCT_SELLER:
      return {
        ...state,
        productObject: { ...state.productObject, ProductSellers: payload },
      };
    case ADD_PRODUCT_FEATURE:
      return {
        ...state,
        productObject: {
          ...state.productObject,
          Features: payload,
          // Features: [...state.productObject.Features, payload],
        },
      };
    case DELETE_PRODUCT_FEATURE:
      return {
        ...state,
        productObject: { ...state.productObject, Features: payload },
      };
    case ADD_SELLER_FEATURE:
      return {
        ...state,
        productObject: {
          ...state.productObject,
          SellerFeatures: (state.productObject.SellerFeatures += payload),
        },
      };
    case DELETE_SELLER_FEATURE:
      return {
        ...state,
        productObject: { ...state.productObject, SellerFeatures: payload },
      };
    case ADD_TAG:
      return {
        ...state,
        productObject: {
          ...state.productObject,
          Tags: (state.productObject.Tags += payload),
        },
      };
    case DELETE_TAG:
      return {
        ...state,
        productObject: { ...state.productObject, Tags: payload },
      };
    case CREATE_PRODUCT_SAGA:
      return { ...state, loading: true };
    case GET_CATEGORIES_SAGA:
      return { ...state, loading: true };
    case GET_SUBCATEGORIES_SAGA:
      return { ...state, loading: true };
    case GET_SECOND_SUBCATEGORIES_SAGA:
      return { ...state, loading: true };
    case GET_CATEGORY_FEATURES_SAGA:
      return { ...state, loading: true };
    case GET_BRANDS_SAGA:
      return { ...state, loading: true };
    case END_CREATION_LOADING:
      return { ...state, loading: false, status: payload };
    default:
      return state;
  }
};

export default createProductReducer;
